import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import Transition from '@ember/routing/-private/transition';
import IndexController from './controller';
import RouterService from '@ember/routing/router-service';

export default class IndexRoute extends Route {
  @service router!: RouterService;

  queryParams = {
    type: {
      refreshModel: false,
    },
    searchType: {
      refreshModel: false,
    },
    sendToUnsubscribed: {
      refreshModel: false,
    },
    page: {
      refreshModel: false,
    },
    searchString: {
      replace: true,
      refreshModel: false,
    },
    searchTagIds: {
      replace: true,
      refreshModel: false,
    },
    sort: {
      refreshModel: false,
    },
    asc: {
      refreshModel: false,
    },
    archived: {
      refreshModel: false,
    },
    state: {
      refreshModel: false,
    },
    subscriptionTopicId: {
      refreshModel: false,
    },
    objectTypeIds: {
      replace: true,
      refreshModel: false,
    },
  };

  async setupController(controller: IndexController, model: null, transition: Transition) {
    super.setupController(controller, model, transition);

    await controller.fetchUserSettings.perform();
    controller.fetchCampaigns.perform().then(() => {
      if (controller.shouldDisplayCampaignsWelcome) {
        this.router.transitionTo('campaigns.welcome');
      }
    });
  }

  resetController(controller: IndexController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.hasFetchedCampaignsAtLeastOnce = false;
      controller.setDefaults();
    }
  }
}
